import React, { useEffect }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import MoreIcon from '@material-ui/icons/MoreVert';
import Home from '@material-ui/icons/Home'
import StorageIcon from '@material-ui/icons/Storage';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

//service
import EstructMenuService from '../../services/EstructMenuService'
import DatasetDynamicService from '../../services/DatasetDynamicService'
import { info, account, clearLocalStorage } from '../../services/Authentication'

//componentes
import HeaderMenu from './HeaderMenu'
import MenuDataset from './MenuDataset'
import ItemMenuRight from './ItemMenuRight'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: -20,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  toolbar:{
    boxShadow:'none',
    backgroundColor:'#000',
  },
  list:{
    textDecoration: 'none',
  },
  dialogContainer:{
    minWidth: 400,
  },  
}));

export default function MenuMain() {  
  const classes = useStyles();  
    
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchor, setAnchor] = React.useState(false)
  const [companyInfo, setCompanyInfo] = React.useState({})
  const [menuDataset, setMenuDataset] = React.useState([])
  const [logoutDialog, setLogoutDialog] = React.useState(false)
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const handlerAnchor = () => {    
    setAnchor(!anchor)
  }

  const loadingInfo = () => {            
    setCompanyInfo(info())   
  }
  const loadingItemsMenu = () => {
    const response = EstructMenuService.itemsMenu()
    response.then(resp => {        
      
    })
    .catch(error => {
      console.error(console.error())
    })
  }

  const loadingItemsMenuDataset = () => {    
    const response = DatasetDynamicService.menu()
    response.then(resp => {              
      setMenuDataset(resp.data)
    })
    .catch(error => {
      console.error(console.error())
    })
  }

  const handleLogoutClose = () => {
    setLogoutDialog(false)
  }
  
  const handleLogoutOpen = () => {
    setLogoutDialog(true)
  }
  

  const logout = () =>{    
    clearLocalStorage()
    setLogoutDialog(false)
    window.location.reload()
  }

  const loadingAll = () =>{
    loadingInfo()
    loadingItemsMenu()
    loadingItemsMenuDataset()
  }

  useEffect(loadingAll, [])

  return (
    
    <div className={classes.root}>    
      
      <AppBar position="static" className={classes.toolbar} >
        
        <Toolbar   >
          
          <IconButton 
              edge="start" 
              className={classes.menuButton} 
              color="inherit" 
              aria-label="menu"
              onClick={handlerAnchor}
          >
            <MenuIcon />
          </IconButton>
          
          <Typography variant="h6" color="inherit" className={classes.title} >
            {companyInfo.nomeEmpresa}
          </Typography>
          
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              {account().empresa === 12?(
                <div>
                  <ItemMenuRight url="/connectors" icon={<StorageIcon/>} label="Conectores" />              
                  <ItemMenuRight url="/connectors/add" icon={<StorageIcon/>} label="Adicionar Conector" />              
                  <ItemMenuRight url="/dataset" icon={<SettingsInputComponentIcon/>} label="Dataset" />              
                  <ItemMenuRight url="/dataset/add" icon={<SettingsInputComponentIcon/>} label="Adicionar Dataset" />              
                  <ItemMenuRight url="/dataset/order" icon={<SettingsInputComponentIcon/>} label="Ordenar Dataset" />
                  <ItemMenuRight url="/dashboad/list" icon={<StorageIcon/>} label="Dashboards" />
                  <ItemMenuRight url="/dashboad/add" icon={<StorageIcon/>} label="Adicionar Dashboards" />
                </div>
              ):''}              
              <ItemMenuRight eventToClick={handleLogoutOpen} icon={<ExitToAppIcon/>} label="Sair" />              
                          
            </Menu>
                  
        </Toolbar>
      </AppBar>

      <div className={classes.fullList} >
          <Drawer             
            open={anchor} 
            anchor="left"     
            onClose={handlerAnchor}        
          >
            <HeaderMenu info={companyInfo} />           

            <Divider/>
            <ItemMenuRight url="/" icon={<Home/>} label="Home" />                          
            <Divider/>
            {menuDataset.map(data => <MenuDataset key={data.id} info={data}  anchor={handlerAnchor} />)}            
        </Drawer>
        </div>

        <Dialog          
          open={logoutDialog}
          onClose={handleLogoutClose}  
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"  
        >
          <DialogTitle >{"Você está saindo?"}</DialogTitle>
          <DialogContent className={classes.dialogContainer} >
            <DialogContentText id="alert-dialog-description">
              Deseja realmente sair?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLogoutClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={logout} color="primary" autoFocus>
              Sair
            </Button>
          </DialogActions>
      </Dialog>

    </div>
  );
}